import React from 'react';
import { Menu, Icon } from 'antd';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import { firebaseConnect } from 'react-redux-firebase';
import { translate } from 'react-i18next';
import { history } from '../../store';
import Logo from '../../images/LogoCircle.png'
require('../../styles/nav.css');


class Nav extends React.Component {

  render() {

    const { t } = this.props;
      return (
        <div style={{display: 'inline-flex', backgroundColor: 'white'}}>
        <img style={logo} src={Logo} />
        <Menu mode="horizontal" defaultSelectedKeys="schools" style={{height: '82px'}}>
            <Menu.Item key="schools"><Link to="/">{t('Schools')}</Link></Menu.Item>
            <Menu.Item key="admins"><Link to="/admins">{t('School Admins')}</Link></Menu.Item>
            <Menu.Item key="users"><Link to="/users">{t('Users')}</Link></Menu.Item>
        </Menu>
        </div>
      )
  }
}

const enhancer = compose(
  firebaseConnect(),
  translate('lang'),
)
export default enhancer(Nav);

const logo = {
  width: 'auto',
  height: 70,
  marginTop: 6,
  marginLeft: 20
}



// WEBPACK FOOTER //
// ./src/components/NavSTAdmin/index.jsx